import * as v from 'valibot';
import { AuditActionSchema } from './audit.js';
import { IdSchema, UserIdSchema, JsonSchema, ResourceTypeSchema, TimestampSchema } from './common.js';
export const ActivityReportActions = [
    'file_viewed',
    'file_downloaded',
    'folder_downloaded',
    'room_entered',
    'login',
    'login_attempt',
    'login_magic_link_sent'
];
export const ActivityReportActionSchema = v.picklist(ActivityReportActions);
export const ActivityReportGroupBySchema = v.picklist([
    'user',
    'room'
]);
export const ActivityReportQuerySchema = v.object({
    groupBy: v.optional(ActivityReportGroupBySchema, 'user'),
    subjectId: v.optional(UserIdSchema),
    action: v.optional(ActivityReportActionSchema),
    since: v.optional(TimestampSchema),
    until: v.optional(TimestampSchema),
    /** Opaque cursor from the previous page's `nextCursor` (keyset pagination). */
    cursor: v.optional(v.pipe(v.string(), v.minLength(1))),
    limit: v.optional(v.pipe(v.string(), v.transform((s) => Number(s)), v.number(), v.integer(), v.minValue(1), v.maxValue(1000)), '100')
});
export const ActivityReportActionCountSchema = v.object({
    action: AuditActionSchema,
    count: v.number()
});
export const ActivityReportSummarySchema = v.object({
    totalActivity: v.number(),
    activeUsers: v.number(),
    activeRooms: v.number(),
    mostActiveAction: v.nullable(ActivityReportActionCountSchema),
    countsByAction: v.array(ActivityReportActionCountSchema),
    groupBy: ActivityReportGroupBySchema,
    since: v.nullable(TimestampSchema),
    until: v.nullable(TimestampSchema),
    generatedAt: TimestampSchema
});
export const ActivityReportGroupSchema = v.object({
    subjectType: ActivityReportGroupBySchema,
    subjectId: UserIdSchema,
    label: v.string(),
    totalActivity: v.number(),
    lastActivityAt: TimestampSchema,
    countsByAction: v.array(ActivityReportActionCountSchema)
});
export const ActivityReportDetailSchema = v.object({
    id: IdSchema,
    timestamp: TimestampSchema,
    actorId: v.nullable(UserIdSchema),
    actorType: v.picklist(['user', 'agent']),
    actorEmail: v.nullable(v.string()),
    action: AuditActionSchema,
    resourceType: v.nullable(ResourceTypeSchema),
    resourceId: v.nullable(IdSchema),
    roomId: v.nullable(IdSchema),
    roomName: v.nullable(v.string()),
    metadata: v.nullable(JsonSchema),
    ipAddress: v.nullable(v.string()),
    traceId: v.nullable(v.string())
});
export const ActivityReportResponseSchema = v.object({
    summary: ActivityReportSummarySchema,
    groups: v.array(ActivityReportGroupSchema),
    detail: v.array(ActivityReportDetailSchema),
    nextCursor: v.nullable(v.string())
});
//# sourceMappingURL=report.js.map